import React from 'react';
import withIcon from '../utilities/withIcon';

const IconCheckBox = () => {
  return (
    <g>
      <path d="m15.6646 2.33a.75.75 0 0 0 -1.0605 0l-7.2341 7.234-3.2191-3.2193a.75.75 0 1 0 -1.0609 1.0606l3.75 3.75a.75.75 0 0 0 1.0605 0l7.7642-7.7642a.75.75 0 0 0 -.0001-1.0611z" />
      <path d="m13.8457 7.12a.75.75 0 0 0 -.75.75v6.5835h-11.48v-12.9071h11.5288a.75.75 0 0 0 0-1.5h-12.2788a.75.75 0 0 0 -.75.75v14.4072a.75.75 0 0 0 .75.75h12.98a.75.75 0 0 0 .75-.75v-7.3336a.75.75 0 0 0 -.75-.75z" />
    </g>
  );
};

export default withIcon(IconCheckBox);
